/**
 * @fileoverview Medication History Management API Module
 * This module provides comprehensive API functions for managing member medications including:
 * - Fetching paginated medication lists with search functionality
 * - Adding new prescription (Rx) records to member profiles
 * - Editing existing medication information
 * - Discontinuing medications with status updates
 * - Retrieving detailed medication history and tracking
 * - Search and filtering capabilities for medication management
 */

import api from "./api";

export const fetchMedications = async (memberId, searchTerm, page, size) => {
  try {
    const params = new URLSearchParams();
    const hasSearch = searchTerm && searchTerm.trim() !== "";
    if (!hasSearch && size !== undefined && size !== null) {
      params.append("size", size);
    }
    if (!hasSearch && page !== undefined && page !== null) {
      params.append("page", page);
    }
    if (searchTerm) {
      params.append("search", searchTerm);
    }

    const response = await api.get(
      `/api/members/${memberId}/medications?${params.toString()}`,
      {
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      }
    );
    return response.data;
  } catch (e) {
    return `fetchMedications failed: ${e instanceof Error ? e.message : String(e)}`;
  }
};

export const addRx = async (memberId, payload) => {
  try {
    const response = await api.post(
      `/api/members/${memberId}/medications`,
      payload
    );
    return response.data;
  } catch (e) {
    return `addRx failed: ${e instanceof Error ? e.message : String(e)}`;
  }
};

export const EditRx = async (memberId, medicationId, payload) => {
  try {
    const response = await api.put(
      `/api/members/${memberId}/medications/${medicationId}`,
      payload
    );
    return response.data;
  } catch (e) {
    return `EditRx failed: ${e instanceof Error ? e.message : String(e)}`;
  }
};

export const discontinueRx = async (medicationId, memberId, payload) => {
  try {
    const response = await api.patch(
      `/api/members/${memberId}/medications/${medicationId}`,
      payload
    );
    return response.data;
  } catch (e) {
    return `discontinueRx failed: ${e instanceof Error ? e.message : String(e)}`;
  }
};

export const fetchMedicationHistory = async (memberId, payload, page, size) => {
  try {
    const params = new URLSearchParams();
    if (page !== undefined && page !== null) {
      params.append("page", page);
    }
    if (size !== undefined && size !== null) {
      params.append("size", size);
    }
    const queryString = params.toString();
   const baseUrl = `/api/members/${memberId}/medications/rx-history`;
   const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

    const response = await api.post(
      url,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      }
    );
    return response.data;
  } catch (e) {
    return `fetchMedicationHistory failed: ${e instanceof Error ? e.message : String(e)}`;
  }
};
